<div class="column">
  <mat-tab-group class="sub-tabs">
    <mat-tab label="Ore/Commesse Report">
      <div class="filter-container">
        <!-- download a report of hours spent in projects during a timeframe -->
        <mat-form-field style="width: 140px;" appearance="outline" subscriptSizing="dynamic">
          <input #oreCommesseFromDate [matDatepicker]="oreCommesseFromDatePicker"
            [value]="oreCommesseFromDateSubject.value" matInput
            placeholder="From Date">
            <mat-datepicker-toggle [for]="oreCommesseFromDatePicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #oreCommesseFromDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field style="width: 140px; margin-left: 10px;" appearance="outline" subscriptSizing="dynamic">
            <input #oreCommesseToDate [matDatepicker]="oreCommesseToDatePicker"
              [value]="oreCommesseToDateSubject.value" matInput
              placeholder="To Date">
              <mat-datepicker-toggle [for]="oreCommesseToDatePicker" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #oreCommesseToDatePicker></mat-datepicker>
            </mat-form-field>

            <button (click)="generateOreCommesseReport()" [disabled]="loading" color="primary" i18n
              mat-raised-button>
                    Generate
                </button>
          </div>
        </mat-tab>
        <mat-tab label="Filtered Budgets Report">
          <div class="filter-container">
            <!-- download a report made of filtered list of budget -->
            <app-budget-list-filter></app-budget-list-filter>
            <button (click)="generateFilteredReport()" [disabled]="loading" color="primary" i18n mat-raised-button>
                    Generate
                </button>
          </div>
        </mat-tab>
        <mat-tab label="Filtered Budgets Summary Report">
          <div class="filter-container">
            <!-- download a report made of filtered list of budget -->
            <app-budget-list-filter></app-budget-list-filter>
            <button (click)="generateFilteredSummaryReport()" [disabled]="loading" color="primary" i18n mat-raised-button>
                    Generate
                </button>
          </div>
        </mat-tab>
        <mat-tab label="Hours Report">
          <div class="filter-container">
            <mat-form-field style="width: 140px;" appearance="outline" subscriptSizing="dynamic">
              <input #reportFromDate [matDatepicker]="reportFromDatePicker" [value]="reportDateFromSubject.value"
                matInput
                placeholder="From Date">
                <mat-datepicker-toggle [for]="reportFromDatePicker" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #reportFromDatePicker></mat-datepicker>
              </mat-form-field>

              <mat-form-field style="width: 140px; margin-left: 10px;" appearance="outline" subscriptSizing="dynamic">
                <input #reportToDate [matDatepicker]="reportToDatePicker" [value]="reportDateToSubject.value"
                  matInput
                  placeholder="To Date">
                  <mat-datepicker-toggle [for]="reportToDatePicker" matSuffix></mat-datepicker-toggle>
                  <mat-datepicker #reportToDatePicker></mat-datepicker>
                </mat-form-field>

                <button (click)="downloadHourReport()" [disabled]="loading" color="primary" i18n mat-raised-button style="margin-left: 10px">
                    Generate
                </button>
              </div>
            </mat-tab>
          </mat-tab-group>


          <mat-card class="full-width no-p mb-1">
            <div class="example-container mat-elevation-z8 table-container">

              <mat-table [dataSource]="reportFiles" matSort>

                <ng-container matColumnDef="createdAt">
                  <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Created At</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    {{ row.createdAt|timestamp | date:'long' }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="endAt">
                  <mat-header-cell *matHeaderCellDef i18n mat-sort-header>End At</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    {{ row.endAt|timestamp | date:'long' }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="status">
                  <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Status</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    {{ row.status }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="fileReference">
                  <mat-header-cell *matHeaderCellDef i18n mat-sort-header>File</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    @if (row.fileReference) {
                      <a class="is-link"
                      (click)="openOreCommesseLink(row.id)">Download Report</a>
                    }
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="type">
                  <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Type</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    {{ row.type }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="period">
                  <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Period</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    {{ row.from }} - {{ row.to }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="details">
                  <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Details</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    {{ row.details }}
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="reportsColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: reportsColumns;"></mat-row>
              </mat-table>

              <mat-paginator [pageSizeOptions]="[25, 50, 100, 1000]"></mat-paginator>
            </div>
          </mat-card>

        </div>